import { Injectable, inject } from '@angular/core';
import {
  DetectionService,
  RenderService,
  SimulationService,
  TaskService,
} from '@services';
import '@tensorflow/tfjs-backend-webgl';
import { AnatomoMetricsService } from './anatomo-metrics.service';
import { SharedService } from './shared.service';

const WORKERS = {
  cycleWorker: {
    id: 'cycleWorker',
    model: 'default',
    historySize: 20,
    confidence: 0.2,
  },
  piercingBackStitchWorker: {
    id: 'piercingBackStitchWorker',
    model: 'piercingBackStitchTensioner',
    historySize: 20,
    confidence: 0.2,
  },

  suturingPhasesClassification: {
    id: 'suturingPhasesClassification',
    model: 'suturingPhasesClassification',
    historySize: 20,
    confidence: 0.2,
  },
  suturingMistakesClassification: {
    id: 'suturingMistakesClassification',
    model: 'suturingMistakesClassification',
    historySize: 20,
    confidence: 0.2,
  },
};

@Injectable({
  providedIn: 'root',
})
export class AnatomoService {
  private detectionService = inject(DetectionService);
  private anatomoMetricsService = inject(AnatomoMetricsService);
  private taskService = inject(TaskService);
  private renderService = inject(RenderService);
  private shared = inject(SharedService);
  private simulationService = inject(SimulationService);

  constructor() {
    this.detectionService.addWorkers(WORKERS);
    // this.shared.cycleWorkerId = WORKERS.cycleWorker.id;
    // this.shared.piercingBackStitchWorkerId =
    //   WORKERS.piercingBackStitchWorker.id;
    this.shared.suturingPhasesClassificationWorkerId =
      WORKERS.suturingPhasesClassification.id;
    this.shared.suturingMistakesClassificationWorkerId =
      WORKERS.suturingMistakesClassification.id;
  }

  async runDetection() {
    if (this.simulationService.isSimulationRunning()) {
      // await this.detectionService.detect(WORKERS.cycleWorker.id);
      this.shared.messageGeneration();
      // this.shared.startMessageResetTimer();
      await this.detectionService.detect(
        WORKERS.suturingPhasesClassification.id,
      );
      await this.detectionService.detect(
        WORKERS.suturingMistakesClassification.id,
      );
      if (this.simulationService.state() === 'simulation') {
        // this.shared.toolTracking();
        switch (this.taskService.currentTaskId()) {
          case 'prepareMaterials': {
            this.shared.prepareMaterials().then(async (isConfirmed) => {
              if (isConfirmed) {
                this.renderService.clearDynamicOverlays();
                await this.renderService.waitForStaticCleanup();
                await this.taskService.completeTask('prepareMaterials');
              }
            });
            break;
          }
          case 'fixation': {
            this.shared.fixation().then(async (isConfirmed) => {
              if (isConfirmed) {
                this.renderService.clearDynamicOverlays();
                await this.renderService.waitForStaticCleanup();
                await this.taskService.completeTask('fixation');
              }
            });
            break;
          }
          case 'tieKnot': {
            this.shared.tieKnot().then(async (isConfirmed) => {
              if (isConfirmed) {
                this.renderService.clearDynamicOverlays();
                await this.renderService.waitForStaticCleanup();
                await this.taskService.completeTask('tieKnot');
              }
            });
            break;
          }
          case 'lockStitch': {
            await this.detectionService.detect(
              WORKERS.piercingBackStitchWorker.id,
            );
            this.shared.lockStitch().then(async (isConfirmed) => {
              if (isConfirmed) {
                await this.taskService.completeTask('lockStitch');
              }
            });
            break;
          }
          case 'closeWoundInProgress': {
            await this.detectionService.detect(
              WORKERS.piercingBackStitchWorker.id,
            );
            this.shared.closeWoundInProgress().then(async (isConfirmed) => {
              if (isConfirmed) {
                await this.taskService.completeTask('closeWoundInProgress');
              }
            });
            break;
          }
          case 'closeWound': {
            await this.detectionService.detect(
              WORKERS.piercingBackStitchWorker.id,
            );
            this.shared.closeWound().then(async (isConfirmed) => {
              if (isConfirmed) {
                await this.taskService.completeTask('closeWound');
              }
            });
            break;
          }

          case 'cutSuture': {
            if (!this.taskService.taskListCompleted()) {
              this.shared.cutSuture().then(async (isConfirmed) => {
                if (isConfirmed) {
                  await this.taskService.completeTask('cutSuture');
                }
              });
            }
            break;
          }
        }
      }
    }
  }

  stopDetection() {
    this.anatomoMetricsService.finalizeMetrics();
    this.detectionService.terminateAllworkers();
  }
}
